
import {Vue, Component, Prop, Mixins} from 'vue-property-decorator';
import NewFormWrapper from "@/components/NewFormWrapper.vue";
import FormDialog from "@/components/dialogs/FormDialog.vue";
import MahrumiyetInfo from "@/components/infos/eicrapro/MahrumiyetInfo.vue";
import BankaHacziTalepEvrakForm from "@/components/forms/uyap-evrak/haciz-evrak/BankaHacziTalepEvrakForm.vue";
import IhbarnameTalepEvrakForm from "@/components/forms/uyap-evrak/haciz-evrak/IhbarnameTalepEvrakForm.vue";
import TasinirHacizTalimatiTalepEvrakForm
  from "@/components/forms/uyap-evrak/haciz-evrak/TasinirHacizTalimatiTalepEvrakForm.vue";
import TasinirHacizTalepEvrakForm from "@/components/forms/uyap-evrak/haciz-evrak/TasinirHacizTalepEvrakForm.vue";
import MaasHacziTalepEvrakForm from "@/components/forms/uyap-evrak/haciz-evrak/MaasHacziTalepEvrakForm.vue";
import {UyapHacizEvrakTuru} from "@/plugins/uyap-plugin/enum/uyap/evrak/UyapHacizEvrakTuru";
import {AvukatTalepListCevapRow} from "@/plugins/uyap-plugin/uyap/AvukatTalepList";
import {ITarafBilgisiDetayliTarafRollu} from "@/plugins/uyap-plugin/uyap/GetDosyaTarafListesiWithTarafRol";
import {BorcluTur} from "@/plugins/uyap-plugin/uyap/CommonInterfaces";
import {MDB} from "@/plugins/uyap-plugin/MDB";
import ObjectInputMixin from "@/mixins/ObjectInputMixin.vue";
import {IMahrumiyet} from "@/plugins/uyap-plugin/uyap/DosyaBorcluEgmMahrumiyet";
import BorcluSigortaBilgileri from "@/components/eicrapro/borclu-sigorta/BorcluSigortaBilgileri.vue";
import {
  maasHacziGonderilsinMi,
  MaasHacziSigortaDurumu,
  maasHacziSigortaDurumu
} from "@/plugins/uyap-plugin/utils/maasHacziSigortaDurumu";
import {BankaSorguSatiri, KurumBankaHesabi} from "@/plugins/uyap-plugin/utils/bankaEslestirme";

@Component({
  computed: {
    HacizEvrakTuru() {
      return UyapHacizEvrakTuru
    },
    MDB() {
      return MDB
    }
  },
  components: {
    BorcluSigortaBilgileri,
    MaasHacziTalepEvrakForm,
    TasinirHacizTalepEvrakForm,
    TasinirHacizTalimatiTalepEvrakForm,
    IhbarnameTalepEvrakForm,
    BankaHacziTalepEvrakForm,
    MahrumiyetInfo,
    FormDialog,
    NewFormWrapper}
})
export default class TopluHacizTalepDuzenleForm extends Mixins(ObjectInputMixin) {
  @Prop() talepler!: Array<AvukatTalepListCevapRow>;
  @Prop() dosyaId!: string;
  // Toplu haciz hazırla adımında önden çekilen 3. şahıs listesi (89-1 çoklu form için)
  @Prop() ucuncuSahisList!: Array<ITarafBilgisiDetayliTarafRollu>;

  borcluSigortaBilgileriToggle = false;

  // ObjectInputMixin localValue'yu düz nesne kopyası olarak tuttuğu için DosyaBorclu'nun
  // isKurum() metodu burada yok; alan olarak kopyalanan isKurumBool/turu okunuyor.
  get borcluKurumMu(): boolean {
    const lv = this.localValue as { isKurum?: () => boolean, isKurumBool?: boolean, turu?: number };
    if (typeof lv.isKurum === 'function')
      return lv.isKurum();
    if (typeof lv.isKurumBool === 'boolean')
      return lv.isKurumBool;
    // isKurumBool sonradan eklendi; eski kayıtlarda turu string olarak da gelebiliyor.
    return Number(lv.turu) === BorcluTur.KURUM;
  }

  // Baslik UYAP'in "SGK Haciz" sonucuna degil sigorta sorgularina bakar. (DEV-3353)
  get maasHacziDurumu(): MaasHacziSigortaDurumu {
    return maasHacziSigortaDurumu(this.localValue);
  }

  // Gönderim kapısı kutu açık olsa da aktif kayıt ya da SGK Haciz sonucu istiyor; talep sessizce düşmesin.
  get maasHacziGonderilemez(): boolean {
    return this.localValue.haciz?.maasHacziSelected === true && !maasHacziGonderilsinMi(this.localValue);
  }

  // Seçici sorguda bulunan bankalarla sınırlanır; kurum sonucu da plugin'de banka bazına indiriliyor. (DEV-3513)
  get mevcutBankalarForHacizPicker(): Array<BankaSorguSatiri> | undefined {
    const rows = this.localValue.bankaBilgileri?.sorguSonucDVO;
    return Array.isArray(rows) && rows.length > 0 ? rows : undefined;
  }

  // Kurumda UYAP hesap bazlı dönüyor; hesaplar plugin'de banka altında gruplanıyor. (DEV-3513)
  get bankaHesaplari(): Array<KurumBankaHesabi & { bankaAdi: string, eslesmedi: boolean }> {
    const rows = this.localValue.bankaBilgileri?.sorguSonucDVO;
    if (!Array.isArray(rows))
      return [];
    return rows.flatMap((banka: BankaSorguSatiri) => (banka?.hesaplar || []).map((hesap) =>
        ({...hesap, bankaAdi: banka.bankaAdi, eslesmedi: banka.eslesmedi === true})));
  }

  // takip.task.response.dosya.dosyaId
  showTalep(talepKod: UyapHacizEvrakTuru): boolean {
    return !!this.talepler.find((talep: AvukatTalepListCevapRow) => (talep.talepKodu == talepKod));
  }

  tumunuSec(items: Array<any>) {
    if (items) {
      let selected = !(items.filter(item => item.selected).length == items.length)
      items.forEach(item => {
        item.selected = selected;
      });
      this.input();
    }
  }

  getTakyidatSirasi(items: IMahrumiyet[]) {
    if (!items?.length) return '-';
    return Math.max(...items.map(o => o.takyidatSayisi));
  }
}
